import React, { useRef } from 'react';
import emailjs from 'emailjs-com'; // or remove if you're not using EmailJS
import './Contact.css';

function Contact() {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    // If you want to send the form data via EmailJS:
    emailjs.sendForm(
      'service_q5dlb7k',    // e.g. service_xxx
      'template_olrexdk',   // e.g. template_yyy
      formRef.current,
      'ppsJRHeT9OPOlpdIL'     // e.g. user_abc123
    )
    .then(() => {
      alert('Message sent successfully!');
    })
    .catch((error) => {
      console.error('Email error:', error);
      alert('There was an error sending the message.');
    });

    e.target.reset();
  };

  return (
    <div className="contact-page">
      {/* Logo & nav link can be in a shared Nav component 
          or handled at a higher level. This is just the form. */}
      
      <div className="contact-form-container">
        <form ref={formRef} onSubmit={sendEmail} className="contact-form">
          {/* First row: Name, Title, Company */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name <span>*</span></label>
              <input type="text" id="name" name="user_name" required />
            </div>
            <div className="form-group">
              <label htmlFor="title">Title <span>*</span></label>
              <input type="text" id="title" name="user_title" required />
            </div>
            <div className="form-group">
              <label htmlFor="company">Company <span>*</span></label>
              <input type="text" id="company" name="user_company" required />
            </div>
          </div>

          {/* Second row: Email, Phone Number */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">Email <span>*</span></label>
              <input type="email" id="email" name="user_email" required />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number <span>*</span></label>
              <input type="tel" id="phone" name="user_phone" required />
            </div>
          </div>

          {/* Third row: Full-width Message */}
          <div className="form-row">
            <div className="form-group full-width">
              <label htmlFor="message">Message <span>*</span></label>
              <textarea id="message" name="message" rows="5" required />
            </div>
          </div>

          {/* Send button */}
          <button type="submit" className="send-button">Send</button>
        </form>
      </div>
    </div>
  );
}

export default Contact;